export default {
  title: 'Jobs',
  sections: {
    main: {
      fields: {
        value: {
          title:'Jobs bei Swiss Engineers United',
          subTitle:'Wir freuen uns auf Ihre Bewerbung',
          link:'https://hmq.ch/jobs',
          text: 'Nichts dabei – aber Sie hätten da eine Idee?',
          link2: 'Senden Sie uns Ihre Spontanbewerbung zu'
        },
      }
    }
  }
}
// https://hmq.ch/jobs
